// Analítica (GTM) cargada SOLO tras consentimiento explícito (banner de cookies).
// Antes se cargaba incondicionalmente en el <head>, rastreando incluso a
// usuarios autenticados sin consentimiento previo.

const GTM_ID = 'GTM-NVZ8882K';
const CONSENT_KEY = 'suscri-cookie-consent'; // 'accepted' | 'rejected'

export function getStoredConsent(): 'accepted' | 'rejected' | null {
  try {
    const v = localStorage.getItem(CONSENT_KEY);
    return v === 'accepted' || v === 'rejected' ? v : null;
  } catch {
    return null;
  }
}

export function setStoredConsent(value: 'accepted' | 'rejected'): void {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* localStorage no disponible: no persiste, pero no rompe la app */
  }
}

let loaded = false;

export function loadAnalytics(): void {
  if (loaded || typeof window === 'undefined') return;
  loaded = true;

  (function (
    w: Window & Record<string, unknown[] | undefined>,
    d: Document,
    s: string,
    l: string,
    i: string
  ) {
    const dataLayer = (w[l] = w[l] ?? []);
    dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s) as HTMLScriptElement;
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode?.insertBefore(j, f);
  })(
    window as unknown as Window & Record<string, unknown[] | undefined>,
    document,
    'script',
    'dataLayer',
    GTM_ID
  );

  const noscriptFrame = document.createElement('noscript');
  noscriptFrame.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.prepend(noscriptFrame);
}

export function initAnalyticsFromStoredConsent(): void {
  if (getStoredConsent() === 'accepted') loadAnalytics();
}
